import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { media } from '../assets/js/Helper'
import { vc_base, vc_color } from '../assets/js/Brand'

// components
import Heading from '../components/atoms/BaseHeading'
import Txt from '../components/atoms/BaseTxt'
import Anchor from '../components/atoms/BaseAnchor'
import Breadcrumb from '../components/molecules/Breadcrumb'
import ListItem from '../components/molecules/ListItem'
import Layout from '../components/templates/Default'

// template
const categoryOne = (props) => {
  // 現在の大カテゴリーの情報取得
  const thisCat = props.data.markdownRemark
  // 現在の大カテゴリー名がslugに含まれる全てのファイルを取得
  let interim = props.data.allMarkdownRemark
  // 現在の大カテゴリーに属するファイルをフィルタリングして取得
  let allItem = interim.edges.filter((item) => {
    return (
      item.node.fields.slug.split('/').filter((s) => s !== '')[0] ===
      thisCat.frontmatter.cat
    )
  })
  // 取得したファイルから現在の大カテゴリーに属する中カテゴリーを抜き出す
  const catTwoAll = allItem.filter(
    (cat) => cat.node.frontmatter.posttype === 'catTwo'
  )
  // 取得したファイルから現在の大カテゴリーの記事を抜き出す
  const allPost = allItem.filter(
    (post) => post.node.frontmatter.posttype === 'post'
  )
  // 現在の大カテゴリーの記事の総数取得
  const totalCount = allPost.length

  // 記事並び替え用関数
  function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const targetA = a.node.frontmatter.date
    const targetB = b.node.frontmatter.date
    let comparison = 0
    if (targetA > targetB) {
      comparison = 1
    } else if (targetA < targetB) {
      comparison = -1
    }
    return comparison * -1
  }

  return (
    <Layout catOne={thisCat.frontmatter.cat}>
      <Helmet>
        <html lang="ja" />
        <meta charSet="utf-8" />
        <meta http-equiv="Pragma" content="no-cache" />
        <meta http-equiv="Cache-Control" content="no-cache" />
        <meta http-equiv="Expires" content="0" />
        <title>{thisCat.frontmatter.title}｜ヘルプ</title>
      </Helmet>

      <Breadcrumb />

      <Heading level={1} className="title-page">
        {thisCat.frontmatter.title}
        <TotalCount>（全{totalCount}件）</TotalCount>
      </Heading>

      <div>
        {catTwoAll.map(({ node }) => {
          // 現在の大カテゴリーの記事の中からループしている中カテゴリーに属している記事を抜き出す
          let catTwoAllPost = allPost.filter(
            (post) => ~post.node.fields.slug.indexOf(node.fields.slug)
          )
          // 取得した記事数の取得
          let listCount = catTwoAllPost.length
          // 取得した記事の加工（ソート・10件以上を削除）
          let filteringCatTwoAllPost = catTwoAllPost
            .slice()
            .sort(compare)
            .slice(0, 10)
          return (
            <React.Fragment key={node.id}>
              <PageList>
                <Anchor to={node.fields.slug}>
                  <PageListTitle level={2} className="title-section">
                    {node.frontmatter.title}
                    <TotalCount>（全{listCount}件）</TotalCount>
                  </PageListTitle>
                </Anchor>

                <PageListbox>
                  {filteringCatTwoAllPost.map(({ node }) => {
                    return (
                      <ListItem key={node.id} link={node.fields.slug}>
                        <Txt type={'span'} className="anchor-text">
                          {node.frontmatter.title}
                        </Txt>
                      </ListItem>
                    )
                  })}
                </PageListbox>
              </PageList>

              <PageListAll>
                <Anchor to={node.fields.slug}>
                  <Txt type={'span'} className="anchor-text">
                    {node.frontmatter.title}のご質問（全{listCount}
                    件）を全てみる
                  </Txt>
                </Anchor>
              </PageListAll>
            </React.Fragment>
          )
        })}
      </div>
    </Layout>
  )
}

export default categoryOne

// script
export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }

    allMarkdownRemark(
      sort: { fields: frontmatter___order, order: ASC }
      filter: {
        frontmatter: { kind: { eq: "faq" } }
        fields: { slug: { regex: $slug } }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            kind
            posttype
            cat
            order
            title
            date
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

// style
const TotalCount = styled.span`
  font-size: 65%;
  font-weight: normal;
`
const PageList = styled.div`
  border: 1px solid ${vc_color.border};
  border-radius: ${vc_base.pixel`0.5`};
  margin-top: ${vc_base.pixel`5`};
  &:first-child {
    margin-top: ${vc_base.pixel};
  }
`
const PageListTitle = styled(Heading)`
  padding-bottom: ${vc_base.pixel`2.5`};
  padding-left: ${vc_base.pixel`2.5`};
  padding-right: ${vc_base.pixel`2.5`};
  padding-top: ${vc_base.pixel`2.5`};
`
const PageListbox = styled.ul`
  border-top: 1px solid ${vc_color.border};
`
const PageListAll = styled.p`
  margin-top: ${vc_base.pixel};
  ${media.Large`
		text-align: right;
	`}
`
